import { computed, defineComponent, type PropType, ref } from 'vue'
import { type LocationGroup, type LocationMethod } from '../../types'
import { getBlankPriceList, getImprintPriceList, useWindow, getProductionTimeByQtyRange,getTotalQty} from '../../composables'
import { ApDialog, ApButton } from "@anypromo/components-pc"
import { isEmptyObject } from '../../utils'
import { type ProductionTimeGroup, type ProductionTimeGroupItem } from './type'
import { useApp } from '../../store/modules/app'
import { calcDelivery } from '@/api/OrderCustomizeClient'
import { useProductSpec } from '../../store/modules/productSpec'
import { useOrder } from '../../composables/use-order'

export default defineComponent({
  components: {
    ApDialog,
    ApButton
  },
  props: {
    isBlank: { type: Boolean, default: false },
    visible: { type: Boolean, default: true },
    callback: Function as PropType<() => void>
  },
  emits: ['update:visible', 'close'],
  setup(props, { emit }) {
    const { isQuote } = useOrder();

    const updateShow = (show: boolean) => emit('update:visible', show)
    const visibleSync = computed({
      get() { return props.visible },
      set(value: boolean) { updateShow(value) }
    })

    const { locationGroupList, productId } = useWindow()
    const { transitTime, } = useApp();
    const productSpecState = useProductSpec();

    // 计算ETA
    let eta = ''
    productSpecState.getSelectedList.forEach(item => {
      if (Array.isArray(item.quantity)) {
        item.quantity.forEach(qty => {
          if (qty.stock?.eta) {
            eta = qty.stock.eta
          }
        })
      } else {
        if (item.quantity.stock?.eta) {
          eta = item.quantity.stock.eta
        }
      }
    })

    const productionTimeGroups = ref<ProductionTimeGroup[]>([])

    const dic: Record<string, LocationMethod[]> = {}
    locationGroupList.forEach((item: LocationGroup) => {
      item.Methods.forEach(method => {
        if (!dic[method.Method]) {
          dic[method.Method] = [method]
        } else {
          dic[method.Method].push(method)
        }
      })
    })

    const priceList = computed(() => props.isBlank ? getBlankPriceList() : getImprintPriceList())
    var totalQty = getTotalQty(productSpecState.getSelectedList)
    for (const key in dic) {
      const methods = dic[key]
      const list: ProductionTimeGroupItem[] = []
      priceList.value.forEach(price => {
        methods.forEach(async (method) => {
          // 先判断是否包含当前的
          if (price.ImprintMethodLimitation.length === 0 || price.ImprintMethodLimitation.includes(method.Method)) {
            let priceName: string, productionTime: any
            if (price.RushDay < 999) {
              priceName = price.RushDay + '-Day Rush'
              productionTime = price.RushDay
            } else {
              productionTime = (method.ProductionTimeRange != null && method.ProductionTimeRange !== "" ? getProductionTimeByQtyRange(method.ProductionTimeRange, totalQty, price.Price) : method.ProductionTime)
              priceName = productionTime + '-Day Service'
            }
            let found = list.find((item) => item.productionTime === productionTime)

            if (!found) {
              found = {
                priceName: priceName,
                priceTitle: priceName,
                isImprint: price.BlankLimitation === 0 || price.BlankLimitation === 1,
                isBlank: price.BlankLimitation === 0 || price.BlankLimitation === 2,
                specLimitation: price.SpecLimitation,
                minQty: Math.max(price.MinQty, method.MinQty),
                maxQty: price.MaxQty,
                maxColors: price.MaxColors,
                imprintLocationNum: price.ImprintLocationNum,
                productionTime: productionTime
              }
              list.push(found)
            } else {
              if (method.MinQty > 0) {
                found.minQty = Math.max(found.minQty, method.MinQty)
              }
            }

            if (found) {
              if (isQuote !== true) {
                calcDelivery({
                  Eta: eta,
                  TransitTime: transitTime,
                  ProductID: productId,
                  ProductionList: [productionTime]
                }).then((data: string[]) => {
                  if (found) {
                    found.priceTitle = data[0]
                  }
                })
              }
            }
          }
        })
      })
      list.sort((a, b) => a.productionTime - b.productionTime)
      productionTimeGroups.value.push({
        name: methods[0].Method,
        priceList: list
      })
    }

    const allMinQty = Math.min(...productionTimeGroups.value.map((item: any) => Math.min(...item.priceList.map((price: any) => price.minQty))))
    const allMaxQty = Math.max(...productionTimeGroups.value.map((item: any) => Math.max(...item.priceList.map((price: any) => price.maxQty))))

    productionTimeGroups.value.forEach((item) => {
      let minQty: number, maxQty: number

      let allSame = item.priceList.every((mi) => {
        if (!minQty) {
          minQty = mi.minQty
        }
        return minQty === mi.minQty && minQty === allMinQty
      })

      if (allSame) {
        item.priceList.forEach(function (mi) {
          mi.minQty = 0
        })
      }

      allSame = item.priceList.every(function (mi) {
        if (maxQty === null) {
          maxQty = mi.maxQty
        }
        return maxQty === mi.maxQty && minQty === allMaxQty
      })

      if (allSame) {
        item.priceList.forEach(function (mi) {
          mi.maxQty = 0
        })
      }
    })
    productionTimeGroups.value.sort((x, y) => {

      return 1;
    })
    const renderListItem = (priceList: ProductionTimeGroupItem[]) => priceList.map(mi => {
      let comma = ''
      let str = ''

      if (mi.minQty > 0) {
        str += comma + 'Minimum Quantity ' + mi.minQty
        comma = ', '
      }
      if (mi.maxQty > 0) {
        str += comma + 'Maximum Quantity ' + mi.maxQty
        comma = ', '
      }
      if (mi.imprintLocationNum > 0 && mi.imprintLocationNum < 999 && mi.maxColors > 0 && mi.maxColors < 999) {
        str += comma + mi.imprintLocationNum + ' Location' + (mi.imprintLocationNum > 1 ? 's' : '')
        str += ' & ' + mi.maxColors + ' Color' + (mi.maxColors > 1 ? 's' : '')
      } else if (mi.imprintLocationNum > 0 && mi.imprintLocationNum < 999) {
        str += comma + mi.imprintLocationNum + ' Location' + (mi.imprintLocationNum > 1 ? 's' : '')
        comma = ', '
      } else if (mi.maxColors > 0 && mi.maxColors < 999) {
        str += comma + '' + mi.maxColors + ' Color' + (mi.maxColors > 1 ? 's' : '')
        comma = ', '
      }

      if (isEmptyObject(mi.specLimitation) === false) {
        str += ' for limited colors.'
        comma = ', '
      }

      return (<div class="s">
        <label>{mi.priceTitle}</label>
        {str}
      </div>)
    })

    const renderList = (priceList: ProductionTimeGroup[]) => priceList.map(price => (<tr>
      <td>{price.name}</td>
      <td>
        {renderListItem(price.priceList)}
      </td>
    </tr>))

    const onClose = () => {
      emit('close')
      // updateShow(false)
      if (props.callback) {
        props.callback()
      }
    }

    return () => {
      return (<ap-dialog mask={true} v-model={visibleSync.value} draggable customClass="production-group" title="Information" style="--ap-dialog-width:600px;">
        <div style="text-align:center" class="production-group">
          <div class="production-group__content">
            <table class="production-group__table">
              <tr>
                <th class="border-left" >Imprint</th>
                <th class="border-left">Production Time</th>
              </tr>
              {renderList(productionTimeGroups.value)}
            </table>
          </div>
          <div class="production-group__btns">
            <ap-button type="primary" size="small" onClick={onClose}>OK</ap-button>
          </div>
        </div>
      </ap-dialog>)
    }
  }
})
